import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { Order } from '../order.interface';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { WsService } from '../../shared/services/ws.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { OrderFormComponent } from '../order-form/order-form.component';
import { Client } from '../../shared/services/client';
import { OrderFormDeleteComponent } from '../order-form-delete/order-form-delete.component';
import { OrderFormDriverCompleteComponent } from '../order-form-driver-complete/order-form-driver-complete.component';
import { OrderFormDriverDriverUnassignComponent } from '../order-form-driver-driver-unassign/order-form-driver-driver-unassign.component';
import { OrderIncressTimeComponent } from '../order-incress-time/order-incress-time.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { HistoryService } from '../../shared/services/history.service';
import { StateService } from '../../shared/services/state.service';
import { OrderService } from '../../shared/services/order.service';
import { LockService } from '../services/lock.service';
import { SettingsService, EventMessageComponent } from '@app/shared';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('pass_phone', { read: ElementRef }) pass_phone: ElementRef;
  @ViewChild('pass_phone2', { read: ElementRef }) pass_phone2: ElementRef;
  @ViewChild('cab_phone', { read: ElementRef }) cab_phone: ElementRef;
  @ViewChild('extendOrderTime') extendOrderTime: TemplateRef<OrderIncressTimeComponent>;
  @Input() order: Order = null;
  @Input() openWindow;
  @Input() taxiServices;
  @Input() Products;
  @Output() remove = new EventEmitter();
  cash_payment = 0;
  dialogRef: MatDialogRef<any>;
  /*EditOrderDialogComponent |
   DriversPopupComponent |
   AddOrderRemoveComponent |
   AddOrderRemoveDriverComponent |
   CompleteOrderComponent*/

  taxiService = {};
  tab = true;
  vehicleStatus = false;
  date = new Date();
  trip_idStatus = false;
  phone = {
    cc1: null,
    cc2: null,
    cd: null
  };
  extendStatus = false;
  history = [];
  archiveLink = '';
  private componentDestroyed = new Subject();

  isQueryEmpty: boolean = false;

  constructor(
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef,
    private ws: WsService,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private client: Client,
    private stateService: StateService,
    private lockService: LockService,
    private settingsService: SettingsService,
    private hist: HistoryService,
    private orderService: OrderService,
    private snackBar: MatSnackBar
  ) {
    this.http.get(this.client.getTelephonyUrl()).subscribe({
      next: obj => {
        this.stateService.setParameter('callList', obj['data']);
      },
      error: err => {
        console.error(err);
      }
    });
  }

  ngOnChanges() {
    this.stateService.isQueryEmpty.subscribe((value: boolean) => {
      this.isQueryEmpty = value;
    });
    if (this.order) {
      console.log('TCL: OrderDetailComponent -> ngOnChanges -> this.order', this.order);
      this.taxiService = this.taxiServices.find(service => service.id == this.order.service_id);
      this.cash_payment = this.order.fare.amount - this.order.paid_amount;
      this.vehicleStatus = false;
      let driverSip = null;
      let addPhoneSip = null;
      if (this.order.cab !== null) {
        driverSip = this.order.cab.driver.phone_number;
      }
      if (this.order.phone_number !== null) {
        addPhoneSip = this.order.phone_number;
      }

      this.order.trip_id !== null ? (this.trip_idStatus = true) : (this.trip_idStatus = false);
      this.phone = {
        cc1: this.sanitizer.bypassSecurityTrustUrl('sip:' + this.order.passenger.phone_number),
        cc2: this.sanitizer.bypassSecurityTrustUrl('sip:' + addPhoneSip),
        cd: this.sanitizer.bypassSecurityTrustUrl('sip:' + driverSip)
      };

      if (!this.tab) {
        this.hist.getHistoryOrder({ id: this.order.id }).subscribe(obj => {
          this.history = obj['data']
            .map(item => {
              if (item.created_at) {
                item.created_at = new Date(Date.parse(item.created_at) + +localStorage.getItem('timezone') * 1000);
              }
              return item;
            })
            .sort((a, b) => {
              return +new Date(a.created_at) - +new Date(b.created_at);
            });
          this.cd.detectChanges();
        });
      }
      this.archiveLink = `${environment.config.white_front}archive/request/${this.order.id}`;
    }
  }

  ngOnInit() {
    this.ws.message.pipe(takeUntil(this.componentDestroyed)).subscribe(data => {
      let res = JSON.parse(data);
      if (res.header.type.toLowerCase() == 'req') {
        if (res.header.action == 'unlock') {
          if (
            this.dialogRef != null &&
            this.dialogRef.componentInstance['data']['order'] &&
            res.data &&
            this.dialogRef.componentInstance['data']['order'].id == res.data.id
          ) {
            const secondsToWait = this.settingsService.settings[
              this.dialogRef.componentInstance['data']['order'].service_id
            ]['requests_operator_lock_timeout'];
            if (secondsToWait > 0) {
              this.handleServiceEvent(`Нельзя редактировать заказ дольше ${secondsToWait / 60} минут`);
              this.dialogRef.componentInstance.editTimeEnd = true;
            }
          }
        } else if (res.header.action == 'delete') {
          if (this.order) {
            if (this.order !== null && this.order.id == res.data.id) {
              this.order = null;
              this.cd.detectChanges();
            }
          }
        } else if (res.header.action == 'update') {
          if (res.data.status.toLowerCase() == 'completed') {
            // remove from list if status completed
            if (this.order !== null && this.order) {
              if (this.order.id == res.data.id) {
                this.order = null;
                this.cd.detectChanges();
              }
            }
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(true);
    this.componentDestroyed.unsubscribe();
  }

  editOrder() {
    console.log('TCL: editOrder -> editOrder', this.dialogRef, this.openWindow);
    if (this.dialogRef || this.openWindow) {
      return;
    }

    let config = new MatDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    config.data = {
      order: this.order,
      taxiServices: this.taxiServices,
      products: this.Products
    };
    config.disableClose = true;
    this.openWindow = true;

    const lockParams = { id: this.order.id };
    if (this.settingsService.settings[this.order.service_id]['sending_round_enabled'] == '1') {
      lockParams['mode'] = 'default';
    }

    this.lockService.lock(lockParams).subscribe(() => {
      this.dialogRef = this.dialog.open(OrderFormComponent, config);
      this.dialogRef.afterClosed().subscribe(res => {
        this.dialogRef = null;
        this.openWindow = false;
        this.lockService.unlock(this.order.id).subscribe(() => {
          this.order.is_locked = false;
        });
      });
    });

    this.dialogRef.afterClosed().subscribe(() => {
      if (this.order.is_locked && this.order.locked_by === localStorage.getItem('user_id')) {
        this.lockService.unlock(this.order.id).subscribe(() => {
          this.order.is_locked = false;
        });
      }
      this.dialogRef = null;
      this.openWindow = false;
      this.cd.markForCheck();
    });
  }

  createOrder() {
    if (this.dialogRef || this.openWindow) {
      return;
    }
    let config = new MatDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    config.data = {
      order: null,
      taxiServices: this.taxiServices,
      products: this.Products
    };
    config.disableClose = true;
    this.openWindow = true;

    this.dialogRef = this.dialog.open(OrderFormComponent, config);
    this.dialogRef.afterClosed().subscribe(() => {
      this.openWindow = false;
      this.dialogRef = null;
    });
  }

  TelCreateOrder(data) {
    if (this.dialogRef || this.openWindow) {
      return;
    }
    const phone = data.phone_number;

    const check = phone.match(/^38/g) !== null;

    const startOrderInfo = {
      phone: check ? phone : '+38' + phone,
      product: '',
      service: ''
    };
    let dialog = dialogRef.bind(this);
    for (let i = 0; i < this.stateService.getParameter('callList').length; i++) {
      let obj = this.stateService.getParameter('callList')[i];
      if (obj.queue_id == data.queue && !this.openWindow) {
        dialog(obj);
      }
    }

    // this.callList.getOrderQueID( +data['queue'], dialogRef.bind( this ) );

    function dialogRef(item) {
      if (item == undefined) {
        return;
      }
      let prod = this.Products.filter(obj => {
        return obj.id == item.product_id;
      });
      if (!!prod.length) {
        startOrderInfo.product = prod[0];
        startOrderInfo.service = item.service_id;
        let config = new MatDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        config.data = {
          order: null,
          orderInfo: startOrderInfo,
          taxiServices: this.taxiServices,
          products: this.Products
        };
        config.disableClose = true;
        this.openWindow = true;

        this.dialogRef = this.dialog.open(OrderFormComponent, config);
        this.dialogRef.afterClosed().subscribe(() => {
          this.openWindow = false;
          this.dialogRef = null;
        });
      }
    }
  }

  removeOrder() {
    if (this.dialogRef || this.openWindow) {
      return;
    }

    let config = new MatDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    config.width = '270px';
    config.height = '300px';
    config.disableClose = true;
    this.orderService.getRemoveOrderReason(this.order.id).subscribe(e => {
      console.log(e['data']);
      config.data = {
        reason: e['data'],
        id: this.order.id
      };
      this.openWindow = true;
      this.dialogRef = this.dialog.open(OrderFormDeleteComponent, config);
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
        this.openWindow = false;
      });
    });
  }

  completeOrder() {
    if (this.dialogRef || this.openWindow) {
      return;
    }

    let config = new MatDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    config.width = '270px';
    config.height = '200px';
    config.disableClose = true;
    config.data = {
      id: this.order.trip_id
    };
    this.openWindow = true;
    this.dialogRef = this.dialog.open(OrderFormDriverCompleteComponent, config);
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
      this.openWindow = false;
    });
  }

  extendOrder() {
    this.extendStatus = !this.extendStatus;
    this.openWindow = true;
  }

  closeWindow() {
    this.openWindow = false;
    this.extendStatus = false;
  }

  removeOrderDriver() {
    if (this.dialogRef || this.openWindow || this.order.trip_id === null) {
      return;
    }

    let config = new MatDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    config.width = '270px';
    config.height = '300px';
    config.disableClose = true;

    this.orderService.getRemoveOrderCabReason(this.order.trip_id).subscribe(obj => {
      config.data = {
        reason: obj['data'],
        id: this.order.trip_id
      };

      this.openWindow = true;
      this.dialogRef = this.dialog.open(OrderFormDriverDriverUnassignComponent, config);
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
        this.openWindow = false;
      });
    });
  }

  assignVehicleToOrder() {
    this.vehicleStatus = !this.vehicleStatus;
    this.vehicleStatus ? (this.dialog.openDialogs.length = 1) : (this.dialog.openDialogs.length = 0);
  }

  closeVehicleStatus() {
    this.vehicleStatus = false;
  }

  showCause(id, i) {
    this.hist
      .getHistoryCauser({
        id: id
      })
      .subscribe(obj => {
        this.history[i].causer = obj['data'];
        console.log(this.history[i].causer);
        this.cd.detectChanges();
      });
  }

  getFeatureCost(feature) {
    return feature.cost ? `( ${feature.cost}\u20B4 )` : '';
  }

  toggleTab(tab?) {
    if (this.tab) {
      this.hist.getHistoryOrder({ id: this.order.id }).subscribe(obj => {
        this.history = obj['data']
          .map(item => {
            if (item.created_at) {
              console.log(+localStorage.getItem('timezone'));
              item.created_at = new Date(Date.parse(item.created_at) + +localStorage.getItem('timezone') * 1000);
            }
            return item;
          })
          .sort((a, b) => {
            return +new Date(a.created_at) - +new Date(b.created_at);
          });
        console.log(this.history);
        this.cd.detectChanges();
      });
    }
    if (tab == 1 || tab == 0) {
      this.tab = !tab;
    } else {
      this.tab = !this.tab;
    }
  }

  private handleServiceEvent(message): void {
    this.snackBar.openFromComponent(EventMessageComponent, <MatSnackBarConfig>{
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        message
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  hotkeyUpHandler($event) {
    switch (
      $event.keyCode
      /*case 48 : {
       $event.preventDefault();
       break;
       }
       case 49 : {
       $event.preventDefault();
       break;
       }
       case 50 : {
       $event.preventDefault();
       break;
       }
       case 51 : {
       $event.preventDefault();
       break;
       }еф
       case 52 : {
       $event.preventDefault();
       break;
       }
       case 53 : {
       $event.preventDefault();
       break;
       }
       case 54 : {
       $event.preventDefault();
       break;
       }
       case 55 : {
       $event.preventDefault();
       break;
       }
       case 56 : {
       $event.preventDefault();
       break;
       }
       case 57 : {
       $event.preventDefault();
       break;
       }*/
    ) {
    }
    if (this.dialog.openDialogs.length != 0) return;
    if (!this.dialogRef && !this.openWindow) {
      switch ($event.keyCode) {
        case 35: {
          this.editOrder();
          break;
        }
        case 107: {
          console.log($event.keyCode);
          break;
        }
        case 112: {
          if (!!this.pass_phone) {
            <HTMLElement>this.pass_phone.nativeElement.click();
          }
          break;
        }
        case 113: {
          console.log($event.keyCode);
          if (!!this.pass_phone2) {
            <HTMLElement>this.pass_phone2.nativeElement.click();
          }
          break;
        }
        case 114: {
          if (!!this.cab_phone) {
            <HTMLElement>this.cab_phone.nativeElement.click();
          }
          break;
        }
        case 115: {
          this.extendOrder();
          break;
        }
        case 45: {
          this.createOrder();
          break;
        }
        case 46: {
          this.isQueryEmpty ? '' : this.removeOrder();
          break;
        }
        case 9: {
          this.toggleTab();
          break;
        }
      }
    }
  }

  @HostListener('document:keydown', ['$event'])
  hotkeyDownHandler($event) {
    /*switch ( $event.keyCode ) {
     case  57 : {
     $event.preventDefault();
     break;
     }
  
     case 48  : {
     $event.preventDefault();
     break;
     }
     case 49  : {
     $event.preventDefault();
     break;
     }
     case 50 : {
     $event.preventDefault();
     break;
     }
     case 51 : {
     $event.preventDefault();
     break;
     }
     case  52 : {
     $event.preventDefault();
     break;
     }
     case  53 : {
     $event.preventDefault();
     break;
     }
     case  54 : {
     $event.preventDefault();
     break;
     }
     case 55  : {
     $event.preventDefault();
     break;
     }
     case  56 : {
     $event.preventDefault();
     break;
     }
  
     }*/
    if (
      $event.keyCode === 35 ||
      $event.keyCode === 107 ||
      $event.keyCode === 112 ||
      $event.keyCode === 113 ||
      $event.keyCode === 114 ||
      $event.keyCode === 115
    ) {
      $event.preventDefault();
    }
    if (!this.openWindow && $event.keyCode === 9) {
      $event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/order-detail/order-detail.component.ts